import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './dialog/confirmation-dialog.component';
import { ConfirmationService } from './confirmation.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    declarations: [ConfirmationDialogComponent],
    imports: [CommonModule, TranslateModule.forChild(), MatDialogModule, MatButtonModule, MatSelectModule],
    providers: [ConfirmationService],
})
export class ConfirmationModule {}
